<template>
  <v-card class="mx-2 my-2 proposal-card">
    <v-img
      :src="thumb"
      height="200px"
      lazy-src
      @click="$router.push(url)"
      style="cursor: pointer"
      :class="{ thumbIsMissing }"
      :contain="thumbIsMissing"
    >
    </v-img>
    <v-card-title
      class="proposal-card-title justify-space-between; flex-wrap: no-wrap;"
      @click="$router.push(url)"
    >
      <div>
        <v-badge color="red" :value="notifsCount > 0" left>
          <template v-slot:badge>
            <span>{{ notifsCount }}</span>
          </template>
          <div class="headline">
            {{ host | hostSummary }}
          </div>
        </v-badge>
        <div>{{ host.address }}</div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-layout row>
        <v-flex xs4 lg4 v-if="proposal.distanceCar != null">
          <v-icon>directions_car</v-icon>
          {{ proposal.distanceCar | time }}
        </v-flex>
        <v-flex xs4 lg4 v-if="proposal.distanceTransport != null">
          <v-icon>directions_subway</v-icon>
          {{ proposal.distanceTransport | time }}
        </v-flex>
        <v-flex xs4 lg4 v-if="proposal.distanceCar != null">
          <v-icon>directions_run</v-icon>
          {{ proposal.distanceWalk | time }}</v-flex
        >
      </v-layout>
      <v-select
        v-if="sortable"
        label="Ce bien vous a plu ? Cliquez ici pour le classer"
        :items="POSITIONS"
        :value="proposal.position"
        @change="$emit('updatePosition', { proposal, value: +$event })"
      ></v-select>
      <ProposalStatusLines
        :proposal="proposal"
        class="mt-4"
      ></ProposalStatusLines>
    </v-card-text>
  </v-card>
</template>

<script>
import { API_URL } from "../../../../webapp-commons/config";
import ProposalStatusLines from "./ProposalStatusLines";
const defaultImage = require("../../assets/hil-logo.png");
export default {
  name: "ProposalCard",
  components: { ProposalStatusLines },
  props: { proposal: {}, sortable: { default: false } },
  computed: {
    host() {
      return this.proposal._host;
    },
    url() {
      return `/leases/project/${this.$route.params.lease_id}/proposals/${
        this.host._id
      }`;
    },
    notifsCount() {
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          idEstate === this.host._id &&
          idProject === this.$route.params.lease_id &&
          !seen
      ).length;
    },
    thumb() {
      const { host } = this;
      if (host.photoUrlEstate && host.photoUrlEstate.length > 0) {
        return `${API_URL}/v1/cache/image/${host.photoUrlEstate[0]}.png`;
      } else {
        return defaultImage;
      }
    },
    thumbIsMissing() {
      const { host } = this;
      return !host.photoUrlEstate || host.photoUrlEstate.length === 0;
    }
  },
  data: function() {
    return {
      POSITIONS: [
        { text: "Non classé", value: 99 },
        { text: "Premier", value: 1 },
        { text: "Second", value: 2 },
        { text: "Troisième", value: 3 },
        { text: "Quatrième", value: 4 },
        { text: "Cinquième", value: 5 }
      ]
    };
  },
  methods: {},
  filters: {
    hostSummary({ numberOfRoom, carrez, price }) {
      let data = [];
      if (numberOfRoom != -1) {
        data.push(`${numberOfRoom} pièce${numberOfRoom > 1 ? "s" : ""}`);
      }
      if (carrez != null) {
        data.push(`${carrez}m²`);
      }
      if (price != null) {
        data.push(`${price}€`);
      }
      return data.join(", ");
    }
  }
};
</script>

<style scoped>
.proposal-card-title {
  cursor: pointer;
}
.thumbIsMissing {
  filter: saturate(0);
  background-color: #bcbcbc;
}
</style>
